import React from "react";
import styled from "styled-components";
import {media} from "../../../utils/CalVW";

const BREAKPOINT = 768;

export const LandingFooter = () => {
	return (
		<Container>
			<ContentsWrap>
					<Contents>
						<span>주식회사 나이츠랩 대표 신임식</span>
						<span>사업자등록번호 : 104-34-24444</span>
					</Contents>
				<Contents>
					<span>
						주소 : 대구광역시 달서구 와룡로53길 47, 달서구사회적경제지원센터 204호

					</span>
					<span>
						통신판매업신고번호 : 제2024-대구달서-1494호
					</span>
				</Contents>
				<Contents>
					<span>연락처 : 010-4871-7689</span>
					<span>문의 : hometownad@naver.com</span>
				</Contents>
			</ContentsWrap>
			<Contents>
				{`나이츠랩에서 운영하는 사이트에서 판매되는 모든 상품은 나이츠랩에서 책임지고 있습니다.`}
			</Contents>
		</Container>
	);
};

const Container = styled.footer`
	width: 100%;
	background-color: #FFF;
	z-index: 1;
	position: relative;
	border-top: 1px solid #EEE;
	padding: 40px 60px;
	@media (max-width: ${BREAKPOINT}px) {
		padding: 40px 20px;
	}
`;

const ContentsWrap = styled.div`
	display: flex;
	flex-direction: row;
	gap: 20px;
	@media (max-width: ${BREAKPOINT}px) {
     	flex-direction: column;
			  gap: 10px;
    }
`;

const Contents = styled.div`
	color: #6c6161;
	line-height: 50px;
	display: flex;
	gap: 20px;
	font-size: 13px;
	font-weight: 600; 
	@media (max-width: ${BREAKPOINT}px) {
		line-height: 24px;
		font-size: 12px;
	}
`;

const ContentsGrey = styled.div`
	color: #999;
	white-space: pre-wrap;
	line-height: 50px;
`;
